import { ListSubheader, makeStyles } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface SelectGroupHeaderProps {
  title: string;
  // Separates the group from the previous one; the first group of the list has none
  divider: boolean;
  // Read by MUI's Menu so the header is skipped when choosing the item to focus on open
  disabled: true;
}

// MUI 4 Select clones every child with onClick, role and value to make it selectable. Only the title and divider
// are forwarded to the subheader, so clicking it neither selects an empty value nor closes the menu.
export const SelectGroupHeader = ({ title, divider }: SelectGroupHeaderProps) => {
  const { palette, spacing } = useCustomTheme();

  // Opaque, as the header is sticky. A tint lighter than the grey of hovered, focused or selected options, so a
  // highlighted option next to a header always stands out from it
  const useStyles = makeStyles({
    root: {
      backgroundColor: palette.grey[100],
      borderTop: divider ? `1px solid ${palette.divider}` : 'none',
      lineHeight: `${spacing(4)}px`,
    },
  });
  const classes = useStyles();

  return (
    <ListSubheader component="div" classes={classes}>
      <Font variant="caption" color="textSecondary" uppercase>
        <Text tId={title} strong />
      </Font>
    </ListSubheader>
  );
};
